import type { ExportRenderQualityId } from '@/rendering/export/types'

/** 参考分辨率（1080p）像素面积，用于按画面面积缩放码率 */
const REF_AREA = 1920 * 1080

/** 各渲染质量档位在 1080p 附近的参考视频码率（bps） */
const BASE_BITRATE_BPS: Record<ExportRenderQualityId, number> = {
  draft: 1_500_000,
  standard: 4_000_000,
  high: 10_000_000,
  best: 18_000_000,
}

/**
 * 按分辨率与离线导出质量估算 VP8/VP9 目标视频码率（`VideoEncoder` 的 `bitrate` 字段）。
 *
 * @param width - 帧宽（像素）
 * @param height - 帧高（像素）
 * @param quality - 导出渲染质量（与场景抗锯齿等相关，同时映射编码码率）
 * @returns 夹在合理区间内的 bps 整数值
 */
export function computeExportVideoBitrateBps(
  width: number,
  height: number,
  quality: ExportRenderQualityId,
): number {
  const area = Math.max(1, width * height)
  const scale = area / REF_AREA
  const base = BASE_BITRATE_BPS[quality] ?? BASE_BITRATE_BPS.standard
  /** 用平方根缓和极大分辨率下的码率膨胀 */
  const raw = base * Math.sqrt(Math.min(4, Math.max(0.25, scale)))
  return Math.round(Math.min(35_000_000, Math.max(400_000, raw)))
}
